module.exports = __webpack_public_path__ + "media/images/company-e5b198064154409ae15bdf6e64df2eac.png";